import { PrismicRichText } from '@prismicio/react';
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import { gsap } from 'gsap';
import React, { Component } from 'react';

import bg from '../images/svg--contact-bg.svg';
import { Section } from '../styles/Section';
import {
  CONTACT_FORM,
  clearFieldErrors,
  openRedirect,
  postNetlifyForm,
  readForm,
  validateFields,
} from '../utils/netlifyForm';

class BlockHeroContact extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }

  state = {
    loading: false,
    success: false,
    error: false,
  };

  // componentDidMount() {
  //   const fadeElements = gsap.timeline();
  //   fadeElements.to("#block-contact", {
  //     opacity: 1,
  //     delay: 0.25,
  //   });
  //   fadeElements.from("#block-contact .fade-up", {
  //     duration: 0.7,
  //     opacity: "0",
  //     y: "20%",
  //     stagger: {
  //       amount: "0.5",
  //     },
  //   });
  // }

  submitForm = (e) => {
    if (e) e.preventDefault();

    const form = this.formRef.current;
    const fields = readForm(form);

    clearFieldErrors(form);
    this.setState({ error: false });

    if (!validateFields(form, fields, CONTACT_FORM.required)) {
      return false;
    }

    // Captured by Netlify Forms; see src/utils/netlifyForm.js.
    this.setState({ loading: true });

    const onSuccess = () => {
      this.setState({ success: true, loading: false });
      openRedirect(this.props.slice.primary);
    };

    const onFailure = (err) => {
      console.log(err);
      this.setState({ error: true, loading: false });
    };

    // Two-argument then: only the network/status step can trigger onFailure.
    // A throw inside onSuccess (after Netlify has recorded the submission)
    // must not show "something went wrong" and invite a duplicate send.
    postNetlifyForm(fields, CONTACT_FORM.trimmed).then(onSuccess, onFailure);
  };

  render() {
    const { primary } = this.props.slice;
    const imgData = getImage(primary.image);

    return (
      <Section id="block-contact" className="container relative">
        <div className="grid grid-cols-12 pt-10 md:pt-16">
          <div className="col-span-12 md:col-span-5">
            <h1 className="h2 mt-6 mb-6 color--primary fade-up">
              {primary.heading}
            </h1>
            <p className="text-lg">{primary.content.text}</p>
            <div className="grid grid-cols-5">
              <div className="col-span-5 xl:col-span-4 mb-16">
                <div className="nav--contact flex justify-between mt-6 content--story">
                  <div>
                    <p className="eyebrow mb-3">Email</p>
                    {primary.email && primary.email.length > 6 ? (
                      <p className="small mb-0">
                        <a
                          href={`mailto:${primary.email}`}
                          className="menu--link color--grey-5"
                        >
                          {primary.email}
                        </a>
                      </p>
                    ) : (
                      <></>
                    )}
                    {primary.content_small ? (
                      <PrismicRichText field={primary.content_small.richText} />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <form
                  name="contact"
                  method="POST"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  className={this.state.success ? "form-1" : "form-1 is-active"}
                  onSubmit={this.submitForm}
                  ref={this.formRef}
                  noValidate
                >
                  {/* Required by Netlify for JS-submitted forms */}
                  <input type="hidden" name="form-name" value="contact" />
                  {/* Honeypot: hidden from humans, bots that fill it are dropped by Netlify */}
                  <p hidden>
                    <label>
                      Don’t fill this out if you’re human:{" "}
                      <input name="bot-field" />
                    </label>
                  </p>
                  {/* Filled in at submit time; declared here so Netlify registers the column */}
                  <input type="hidden" name="pageUri" />
                  {/* Sender name + email, used by Netlify as the submission's list label */}
                  <input type="hidden" name="name" />
                  <div className="relative input-group mb-4">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name*"
                      id="first-name"
                    />
                    <label>First Name*</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name*"
                      id="last-name"
                    />
                    <label>Last Name*</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <input
                      type="email"
                      name="email"
                      placeholder="Work Email*"
                      id="email"
                    />
                    <label>Work Email*</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      id="phone"
                    />
                    <label>Phone Number</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <input
                      type="text"
                      name="company"
                      placeholder="Company*"
                      id="company"
                    />
                    <label>Company*</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <input
                      type="text"
                      name="region"
                      placeholder="Location/Country*"
                      id="region"
                    />
                    <label>Location/Country*</label>
                  </div>
                  <div className="relative input-group mb-4">
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Tell us why you are reaching out."
                    />
                  </div>
                  <div className="relative input-group mb-4">
                    <select id="inbound" name="inbound" defaultValue={""}>
                      <option
                        label="How'd you hear about us?"
                        disabled
                        value=""
                      >
                        How'd you hear about us?
                      </option>
                      <option label="Search engine" value="Search engine">
                        Search engine
                      </option>
                      <option label="Social media" value="Social media">
                        Social media
                      </option>
                      <option label="TRC newsletter" value="TRC newsletter">
                        TRC newsletter
                      </option>
                      <option
                        label="Media / online news article"
                        value="Media / online news article"
                      >
                        Media / online news article
                      </option>
                      <option
                        label="Referral / word of mouth"
                        value="Referral / word of mouth"
                      >
                        Referral / word of mouth
                      </option>
                      <option
                        label="Event / conference"
                        value="Event / conference"
                      >
                        Event / conference
                      </option>
                      <option label="Other" value="Other">
                        Other
                      </option>
                    </select>
                  </div>
                  <button
                    type="submit"
                    className="btn--rounded bg--brown"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Sending…" : "Send"}
                  </button>
                  {this.state.error ? (
                    <p className="small mt-4" role="alert">
                      Sorry, something went wrong sending your request. Please
                      try again or email us directly.
                    </p>
                  ) : (
                    <></>
                  )}
                </form>
                <div
                  className={this.state.success ? "form-2 is-active" : "form-2"}
                >
                  <div className="form-2-container">
                    <div className="form-2-content">
                      <p>Thank you for your interest in TRC.</p>
                      <p>A member of our team will be in touch shortly.</p>
                    </div>
                  </div>

                  <img src={bg} alt="" loading="lazy" />
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-6 col-start-7 hidden md:block">
            {imgData ? (
              <GatsbyImage
                image={imgData}
                alt=""
                loading="eager"
                className="radius-56"
              />
            ) : (
              <StaticImage
                src="../images/contact--hero.jpg"
                loading="eager"
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt=""
                className="radius-56"
              />
            )}
          </div>
        </div>
      </Section>
    );
  }
}

export default BlockHeroContact;
